import { render, staticRenderFns } from "./I18nEditor.vue?vue&type=template&id=1685964d&scoped=true&"
import script from "./I18nEditor.vue?vue&type=script&lang=js&"
export * from "./I18nEditor.vue?vue&type=script&lang=js&"
import style0 from "./I18nEditor.vue?vue&type=style&index=0&id=1685964d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1685964d",
  null
  
)

export default component.exports